import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "edit-capability-container"
};
const _hoisted_2 = {
  class: "capability-name"
};
const _hoisted_3 = {
  class: "type-desc"
};
const _hoisted_4 = {
  class: "capability-explain"
};
const _hoisted_5 = {
  key: 0,
  class: "alert-info"
};
const _hoisted_6 = {
  class: "operator-container"
};
import { ref, onMounted } from 'vue';
import { ElButton, ElInput, ElMessage, ElRow, ElSwitch } from 'element-plus';
import { request } from '@/manager/net_manager';
export default {
  __name: 'RoleCapabilityEditCard',
  props: {
    capability: {
      type: Object,
      required: true
    },
    capabilityBaseInfo: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'complete'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const updatesForm = ref({
      id: null,
      value: 0,
      grew_value: 0,
      skilled: false,
      skilled_path: '',
      human_limiter: false,
      extra_limiter: false,
      over_limit_path: ''
    }); // functions
    // const onValueChanged = (value) => {
    //   updatesForm.value.value = value.replace(/\D/g, '')
    // }
    //
    // const onGrewValueChanged = (value) => {
    //   updatesForm.value.grew_value = value.replace(/[^\-\d]/g, '');
    // }

    const removeCapability = () => {
      if (message.value) {
        message.value.close();
      }

      request('capabilities/role_capabilities/remove/', {
        'role_capability_id': updatesForm.value.id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '能力项已清除',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    };

    const updateCapability = () => {
      if (message.value) {
        message.value.close();
      }

      request('capabilities/role_capabilities/update/', {
        'updates': updatesForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '能力项已调整',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      // console.log('onMounted', JSON.stringify(props.capability))
      updatesForm.value = {
        id: props.capability.id,
        value: props.capability.value,
        grew_value: props.capability.grew_value,
        skilled: props.capability.skilled.toString().toUpperCase() === 'TRUE',
        skilled_path: props.capability.skilled_path,
        human_limiter: props.capability.human_limiter.toString().toUpperCase() === 'TRUE',
        extra_limiter: props.capability.extra_limiter.toString().toUpperCase() === 'TRUE',
        over_limit_path: props.capability.over_limit_path
      };
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input_number = _resolveComponent("el-input-number");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "flex-start"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 7
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_2, [_createTextVNode(_toDisplayString(__props.capabilityBaseInfo.desc) + " ", 1), _createElementVNode("span", _hoisted_3, " 「" + _toDisplayString(__props.capabilityBaseInfo.type_desc) + "」 ", 1)])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_4, _toDisplayString(__props.capabilityBaseInfo.explain), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "capability-value-desc"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, [_createTextVNode(" 「能力设定基础：" + _toDisplayString(__props.capabilityBaseInfo.baseValue) + "」 ", 1), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createTextVNode(" 「角色天性基础：" + _toDisplayString(__props.capability.nature_value) + "」 ", 1)]), __props.capability.grew_value < 0 ? (_openBlock(), _createElementBlock("text", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)), _createTextVNode(" 「存在奇遇亏欠值：" + _toDisplayString(__props.capability.grew_value) + "，谨慎删除。当前设计中奇遇调整值随能力删除而清空，不会保留」 ", 1)])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 4,
          span: 13
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "角色为能力进行分配点数", -1)), _createVNode(_component_el_input_number, {
              modelValue: updatesForm.value.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updatesForm.value.value = $event),
              maxlength: "16",
              placeholder: "分配数值",
              round: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "奇遇变化导致的调整点数", -1)), _createVNode(_component_el_input_number, {
              modelValue: updatesForm.value.grew_value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updatesForm.value.grew_value = $event),
              maxlength: "16",
              placeholder: "成长数值",
              round: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "能力专精（80）", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.skilled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updatesForm.value.skilled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "专精途径", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.skilled_path,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updatesForm.value.skilled_path = $event),
              maxlength: "16",
              placeholder: "专精渠道描述",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "人类限度（90）", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.human_limiter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updatesForm.value.human_limiter = $event)
            }, null, 8, ["modelValue"]), _cache[14] || (_cache[14] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "超凡脱俗（300）", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.extra_limiter,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updatesForm.value.extra_limiter = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "超限途径", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.over_limit_path,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => updatesForm.value.over_limit_path = $event),
              maxlength: "16",
              placeholder: "超限渠道描述",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElButton), {
        class: "remove-capability",
        onClick: removeCapability
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" 删除能力 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElButton), {
        onClick: updateCapability
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })])]);
    };
  }

};